import * as React from "react";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 3;
export const CardComparisonAddedBenefitsSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [addedBenefitsIcon, addedBenefitsTitle, addedBenefitsContent] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div className="xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkLayoutFlex space="three">
        <UitkLayoutFlexItem>
          <div dangerouslySetInnerHTML={addedBenefitsIcon} />
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <div>
            <UitkText size={300} weight="medium">
              <div dangerouslySetInnerHTML={addedBenefitsTitle} />
            </UitkText>
            <UitkText size={200}>
              <div dangerouslySetInnerHTML={addedBenefitsContent} />
            </UitkText>
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </div>
  );
};

export default CardComparisonAddedBenefitsSectionEditorial;
